import { render, staticRenderFns } from "./PersonOrgDetailsUserInfoFrund.vue?vue&type=template&id=f666ceac&"
import script from "./PersonOrgDetailsUserInfoFrund.vue?vue&type=script&lang=js&"
export * from "./PersonOrgDetailsUserInfoFrund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports